var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 7.91699C16.7 8.17533 17.925 9.71699 17.925 13.092V13.2003C17.925 16.9253 16.4333 18.417 12.7083 18.417H7.28332C3.55832 18.417 2.06665 16.9253 2.06665 13.2003V13.092C2.06665 9.74199 3.27498 8.20033 6.22498 7.92533",
    stroke: "white",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.16699V12.9003",
    stroke: "white",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7916 11.042L9.99992 13.8337L7.20825 11.042",
    stroke: "white",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.103d01a15db8c8867170593cc2cc6e3f.svg";
export { ForwardRef as ReactComponent };